import { Button } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import { useMarkAsReadNotification } from "~pages/Notifications/hooks/useMarkAsReadNotification.ts";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const PermissionChangeNotificationItem = ({ notification }: Props) => {
  const { formatMessage } = useIntl();
  const { mutateAsync: markAsRead } = useMarkAsReadNotification();
  const { refetch: refetchUserUpdates } = useUserUpdates();
  const { customerId } = useParams();

  const goToDetailsButton = (
    <Button
      type="primary"
      key="goToUserDetails"
      href={`/${customerId}/admin/${notification.data.Sport}/${notification.data.OrganizationId}/user-details`}
      style={{ textDecoration: "none" }}
      onClick={() => {
        if (notification.unread) {
          markAsRead(notification.key);
        }
        refetchUserUpdates();
      }}
    >
      {formatMessage({ id: "button.goToUserDetails" })}
    </Button>
  );

  return <NotificationItemBody notification={notification} icon="fa-cog" customButtons={[goToDetailsButton]} />;
};
